import { createAsyncThunk } from "@reduxjs/toolkit";
import { EventsFilter, EventsStats, ResponseEventList } from "../../entities/event";
import { agent, encodeGetParams } from "../../api";
import { apiUrlV1 } from "../../config/config";

export const getUserEvents = createAsyncThunk(
  'event/get-user-events',
  async (params?: { filter: EventsFilter }): Promise<ResponseEventList | undefined> => {
    try {
      const query = encodeGetParams({ ...params?.filter })
      const response = await agent.get(`${apiUrlV1}/organization/user-events/read/list${query}`)
      if (response.ok) {
        const data = await response.json() as ResponseEventList;
        return data;
      }
      if (!response.ok) {
        throw Error("No response");
      }
      return undefined;
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const getEventsStats = createAsyncThunk(
  'event/get-events-stats',
  async (params: { fromDate: string; toDate: string; events: string[] }): Promise<EventsStats | undefined> => {
    try {
      const qp = new URLSearchParams();
      qp.set('fromDate', params.fromDate);
      qp.set('toDate', params.toDate);
      params.events.forEach(e => qp.append('events[]', e));
      const response = await agent.get(`${apiUrlV1}/organization/user-events/read/stats?${qp.toString()}`);
      if (response.ok) return await response.json() as EventsStats;
      throw new Error('No response');
    } catch {
      throw new Error('Request failed');
    }
  }
);

export interface AnalyticsSummary {
  hourly: { hour: number; count: number }[];
  perGame: {
    game: string;
    opened: number;
    bonuses: number;
    bonusUsers: number;
    allUsers: number;
    triggers: number;
    trigEntries: { triggerId: string; count: number }[];
  }[];
  languages: { lang: string; count: number }[];
  repeatUsers: { one: number; twoThree: number; fourPlus: number };
  multiGame: { games: string[]; count: number }[];
  uniqueUsers: number;
}

export const getAnalyticsSummary = createAsyncThunk(
  'event/get-analytics-summary',
  async (params: { fromDate: string; toDate: string }): Promise<AnalyticsSummary | undefined> => {
    try {
      const qp = new URLSearchParams({ fromDate: params.fromDate, toDate: params.toDate });
      const response = await agent.get(`${apiUrlV1}/organization/user-events/read/analytics-summary?${qp}`);
      if (response.ok) return await response.json() as AnalyticsSummary;
      throw new Error('No response');
    } catch {
      throw new Error('Request failed');
    }
  }
);

export const getActiveUsersInMonthly = createAsyncThunk(
  'event/get-active-users-in monthly',
  async (): Promise<number> => {
    try {
      const response = await agent.get(`${apiUrlV1}/organization/user-events/read/monthly-active-users-count`)
      if (response.ok) {
        const data = await response.json();
        return data;
      }
      if (!response.ok) {
        throw Error("No response");
      }
      return 0;
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)